import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ShipmentModel } from '@app/data-layer/models/common';
import { CompanyModel } from '@app/data-layer/models/companies';
import { EntrySummaryModel } from '@app/data-layer/models/entry-summaries';
import { EsShipmentDetailsFormDesktopComponent } from '../desktop/es-shipment-details-form-desktop/es-shipment-details-form-desktop.component';
import { UntypedFormGroup } from '@angular/forms';
import { FormHelper } from '@helpers/form.helper';

@Component({
  selector: 'app-es-ocr-quick-fix-shipment-type-details',
  templateUrl: './es-ocr-quick-fix-shipment-type-details.component.html',
  styleUrls: ['./es-ocr-quick-fix-shipment-type-details.component.scss'],
})
export class EsOcrQuickFixShipmentTypeDetailsComponent implements OnInit {
  @Input() public entrySummary: EntrySummaryModel;
  @Input() public company: CompanyModel;
  @Output() public dataSaved: EventEmitter<ShipmentModel> = new EventEmitter<ShipmentModel>();

  @ViewChild(EsShipmentDetailsFormDesktopComponent, { static: false })
  public esShipmentDetailsFormDesktopComponent: EsShipmentDetailsFormDesktopComponent;

  public formGroup: UntypedFormGroup;

  constructor(private fh: FormHelper) {}

  public ngOnInit(): void {
    this.formGroup = this.fh.createEntryShipmentFormGroup(this.company?.authorizationAgreementAccepted && !!this.company?.payerUnitNumber);
    this.formGroup.patchValue(this.entrySummary);
  }

  public onSubmit() {
    this.esShipmentDetailsFormDesktopComponent.onSubmit();
    this.dataSaved.emit(this.formGroup.value);
  }
}
